import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { theme } from './constants';
import { isRtlLocale } from '../../../i18n/language';

/**
 * Screens wrap content with ThemeProvider(theme) from constants; that overrides the
 * outer MaterialCssVarsProvider. Without `direction: 'rtl'`, DataGrid keeps
 * theme.direction === 'ltr' while the document is RTL, so header/body horizontal
 * scroll sync breaks (@mui/x-data-grid useGridScroll).
 */
export function DirectionalMaterialThemeProvider({ children }) {
  const { i18n } = useTranslation();
  const direction = isRtlLocale(i18n.language) ? 'rtl' : 'ltr';
  const themeWithDirection = useMemo(() => createTheme(theme, { direction }), [direction]);
  return <ThemeProvider theme={themeWithDirection}>{children}</ThemeProvider>;
}

DirectionalMaterialThemeProvider.propTypes = {
  children: PropTypes.node,
};
